import { Provider } from '@angular/core';
import { AuthService } from './auth.service';
import { AutoAuthService } from './auto-auth.service';

export function createAuthProvider(): Provider {
  return {
    provide: AuthService,
    useClass: AutoAuthService,
  };
}
